import { render, staticRenderFns } from "./OrderSection.vue?vue&type=template&id=6a19b9b9&scoped=true&"
import script from "./OrderSection.vue?vue&type=script&lang=js&"
export * from "./OrderSection.vue?vue&type=script&lang=js&"
import style0 from "./OrderSection.vue?vue&type=style&index=0&id=6a19b9b9&scoped=true&lang=less&"
import style1 from "./fieldSettings.css?vue&type=style&index=1&id=6a19b9b9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a19b9b9",
  null
  
)

export default component.exports